import { render } from "./CharaLink.vue?vue&type=template&id=211968e6&scoped=true"
import script from "./CharaLink.vue?vue&type=script&lang=js"
export * from "./CharaLink.vue?vue&type=script&lang=js"

import "./CharaLink.vue?vue&type=style&index=0&id=211968e6&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211968e6"]])

export default __exports__